import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB7NTyE4y9qOY-sbL0F4cUwOUYF1AhrqJg",
  authDomain: "portal-proveedores-sinec.firebaseapp.com",
  projectId: "portal-proveedores-sinec",
  storageBucket: "portal-proveedores-sinec.firebasestorage.app",
  messagingSenderId: "174730256195",
  appId: "1:174730256195:web:2cecd8d6a3b79a387359f6"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };